import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "d-flex flex-column ms-auto" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]


import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatsWidget',
  props: {
	icon: {
		type: String
	},
	value: {
		type: String
	},
	description: {
		type: String
	},
	link: {
		type: String
	}
},
  setup(__props) {

const props = __props;

const router = useRouter()



function openLink(){
	if(props.link){
		router.push(props.link)
	}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stats-widget d-flex flex-row", { 'clickable' : props.link }]),
    onClick: openLink
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: props.icon
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "value",
        src: props.value
      }, _toDisplayString(props.value), 9, _hoisted_4),
      _createElementVNode("div", {
        class: "description",
        src: props.description
      }, _toDisplayString(props.description), 9, _hoisted_5)
    ])
  ], 2))
}
}

})